import { DeepReadonly } from 'utility-types';
import { AxiosError } from 'axios';
import { ICompany } from '../interfaces';
import { Actions } from '../actions/organizationDetails';
import {
  FETCH_ORGANIZATION_DETAILS_REQUEST,
  FETCH_ORGANIZATION_DETAILS_SUCCESS,
  FETCH_ORGANIZATION_DETAILS_FAILURE
} from '../constants/organizationDetails';

export type State = DeepReadonly<{
  organizationDetails: ICompany | null;
  error: AxiosError | null;
  isFetching: boolean;
}>;

const initialState: State = {
  organizationDetails: null,
  isFetching: false,
  error: null
};

export function reducer(state: State = initialState, action: Actions): State {
  switch (action.type) {
    case FETCH_ORGANIZATION_DETAILS_REQUEST:
      return {
        ...state,
        isFetching: true
      };
    case FETCH_ORGANIZATION_DETAILS_SUCCESS:
      return {
        isFetching: false,
        organizationDetails: action.payload,
        error: null
      };
    case FETCH_ORGANIZATION_DETAILS_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error
      };
    default:
      return state;
  }
}
